export default "__VITE_ASSET__D49O4SJB__"